import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    allRights: 'All Rights Reserved © {year} Digital Sovereignty Foundation',
    docs: 'Docs',
    terms: 'Terms',
    twitter: 'X',
    youtube: 'Youtube',
    telegram: 'Telegram',
    discord: 'Discord',
  },
};
